import { IconButton } from '@mui/material';
import { ConvergeTooltip } from '../../../../presentation/components/converge-tooltip';
import { useRaterActionDispatchContext } from '../data';
import StraightIcon from '@mui/icons-material/Straight';
import SwapVertIcon from '@mui/icons-material/SwapVert';

interface ICascadeLimitAndRetentionTowerButton {
  isFirstRow: boolean;
  isLastRow: boolean;
  limit: number | null | undefined;
  layerUuid: string;
  participantUuid: string;
  isCyberCrime?: boolean;
}

export const CascadeLimitAndRetentionTowerButton = ({
  isFirstRow,
  isLastRow,
  limit,
  layerUuid,
  participantUuid,
  isCyberCrime,
}: ICascadeLimitAndRetentionTowerButton) => {
  const { dispatch, actions } = useRaterActionDispatchContext();

  return (
    <ConvergeTooltip title="Cascade limit & retention in tower">
      <IconButton
        onClick={() => {
          !isCyberCrime
            ? dispatch(
                actions.cascadeTowerLimitAndRetention(
                  limit ?? null,
                  layerUuid,
                  participantUuid
                )
              )
            : dispatch(
                actions.cascadeTowerCyberCrimeLimitAndRetention(
                  limit ?? null,
                  layerUuid,
                  participantUuid
                )
              );
        }}
      >
        {isFirstRow ? (
          <StraightIcon
            sx={{
              transform: 'rotate(180deg)',
            }}
          />
        ) : isLastRow ? (
          <StraightIcon />
        ) : (
          <SwapVertIcon />
        )}
      </IconButton>
    </ConvergeTooltip>
  );
};
